import { Component, OnInit, OnDestroy } from '@angular/core';

import { DataComponent } from '../constant/data.component';
import { ActivatedRoute, Router } from '@angular/router';

import * as _ from 'lodash';
import { ApiAwards } from '../config/api.component';
import { MatSnackBar } from '@angular/material';

@Component({
    selector: 'exq-category',
    templateUrl: './category.component.html',
    styleUrls: ['./dashboard.component.scss']
})

export class CategoryComponent implements OnInit, OnDestroy {
    updateTime = Date.now();
    catpos: number;
    listArray: any;
    listTotalVoter: any;
    pagingList: any;
    totalPage: number;
    currentCat: number;
    typeCat:number; // 1 for reader choice &  0 for normal category
    currentSelected: number = 0;
    tempArraySubmit: Array<any> = [];
    categoryList: Array<any> = [];
    sub: any;
    finishGetData = true;
    dividePage = 3;
    totalCat = 0;
    pageCat = 0;
    expCounter: number = 0;
    currentTime: number = Date.now();

    constructor(private api: ApiAwards, private dataComponent: DataComponent, private route: ActivatedRoute, public snackBar: MatSnackBar, private router: Router) {

        this.api.getCounters().subscribe(
            val => {
                
                this.expCounter = val.json().data.exp_counter;
                // console.log(this.expCounter);
            },
            error => {
                // console.log(error);
            },
            () => {}
        );
    }

    ngOnInit() {
        this.tempArraySubmit = this.dataComponent.dataTemp;

        this.sub = this.route.params.subscribe(params => {
            this.currentCat = +params['cat']; // (+) converts string 'id' to a number
        });

        this.api.getCategories().subscribe(
        value => {
            // console.log(value.json());
            this.categoryList = value.json().data;
            this.typeCat = value.json().data.cat_type;
        },
        error => {

        },
        () => {
            for (let i = 0; i < this.categoryList.length; i++) {

                var findIndex = this.tempArraySubmit.findIndex(
                    e => e.category === this.categoryList[i]._id
                );

                // console.log(findIndex);

                if (findIndex >= 0) {
                    var findIndexCat = this.categoryList.findIndex(e => e._id === this.categoryList[i]._id);
                    if (findIndexCat >= 0) {
                        this.categoryList[findIndexCat].selected = true;
                    }
                }

            }
        }
        );

        this.listTotalVoter = this.dataComponent.votersArray;

    }

    ngOnDestroy() {
        this.sub.unsubscribe();
    }

    selectCategory(val:any){
        this.dataComponent.titleCategory = val.cat_name;
        this.router.navigate(['dashboard', 2024, val.cat_pos]);
    }

    submitVote() {
        // console.log(this.dataComponent.dataTemp);
        if (this.currentTime <= this.expCounter){
            if (this.tempArraySubmit.length > 0){
                this.router.navigate(['finish']);
            } else{
                this.snackBar.open('Please Complete The Voting', 'OK', {
                    duration: 5000,
                }).onAction();
            }
        }
        // this.dataComponent.dataTemp = this.tempArraySubmit;

        // let countCategoryCity = 0;

        // this.tempArrayPaging = [];

        // for (let i = 0; i < this.pagingList.length; i++) {
        //     countCategoryCity = countCategoryCity + _.keys(this.pagingList[i].location).length;
        // }

        // if (countCategoryCity === this.currentSelected && this.tempArraySubmit.length === 36) {
        //     this.router.navigate(['finish']);
        //     this.currentSelected = 0;

        // } else if (this.tempArraySubmit.length !== 36 - countCategoryCity) {

        //     this.snackBar.open('Please Complete The Voting', 'OK', {
        //         duration: 10000,
        //     }).onAction().subscribe(
        //         () => {
        //             this.currentSelected = 0;
        //             this.router.navigate(['reader', 2018, 1]);
        //         });
        // } else {
        //     this.snackBar.open('Please Try Again.', 'OK', {
        //         duration: 10000,
        //     }).onAction().subscribe(
        //         () => {
        //             //console.log('OKAY');
        //         });
        // }

    }

}
